import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { DataService } from '../data/data.service';
import { FormCoreModule } from '../form-core.module';

@Injectable({
  providedIn: FormCoreModule
})
export class InitiateService {

  constructor(private router: Router, private data: DataService, private title: Title) { }

  navigate() {
    const steps = this.data.getSteps()
    this.router.navigate(['step', steps[0].id])
    this.title.setTitle(this.data.getAttributes()['header-name'])
  }
}
